import * as process from "process";

const API_KEY = process.env.REACT_APP_API_KEY;
const SITE_ID = process.env.REACT_APP_JWP_SITE_ID;
const JWP = process.env.REACT_APP_JWP_KEY
const JWP_API_SECRET = process.env.REACT_APP_JWP_API_SECRET;
const JWP_PLAYER = process.env.REACT_APP_JWP_PLAYER;
const REACT_APP_API_URL="https://api-office.whoflex.com";
const URL = {
    API_BASE_URL:REACT_APP_API_URL,
    API_CLIENT_URL:"https://api.whoflex.com" // TODO : remove
};

export { API_KEY, URL, SITE_ID, JWP, JWP_API_SECRET, JWP_PLAYER};